module.exports = __webpack_public_path__ + "img/47.7417938d.jpg";